export interface LegacyProductVendor {
  id: string
  name: string
  userIds: string[]
  country: string
  address: string
  detailAddress: string
  hidden: boolean
}

export const legacyVendorUsers = Array.from({ length: 6 }, (_, index) => ({
  id: `vendor-user-${index + 1}`,
  name: `모의외주 ${String(index + 1).padStart(2, '0')}`,
  username: `mock.vendor.${String(index + 1).padStart(2, '0')}`,
}))

export const legacyProductVendors: LegacyProductVendor[] = [
  {
    id: 'vendor-1',
    name: '모의 제작업체 01',
    userIds: ['vendor-user-1'],
    country: '대한민국',
    address: '모의시 제작로 10',
    detailAddress: 'Mock 1층',
    hidden: false,
  },
  {
    id: 'vendor-2',
    name: '모의 제작업체 02',
    userIds: ['vendor-user-2', 'vendor-user-3'],
    country: '대한민국',
    address: '모의시 제작로 20',
    detailAddress: 'Mock 2층',
    hidden: false,
  },
]
